module.exports = __webpack_public_path__ + "img/facebook-icon.1e80416a.svg";